import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../index';

export const selectUser = (state: RootState) => state.user;
export const selectUserId = (state: RootState) => state.user.id;
export const selectUserEmail = (state: RootState) => state.user.email;
export const selectUserUuid = (state: RootState) => state.user.uuid;
export const selectWorkspaceId = (state: RootState) => state.user.workspaceId;

export const userAuthorizedSelector = createSelector([selectUser], (user) => !!user.id);
